const getErrorPayload = (error) => error?.response?.data || error?.data || error || null;

const getErrorMessage = (error) => {
  const payload = getErrorPayload(error);
  if (typeof payload === "string") return payload;
  return payload?.message || payload?.detail || error?.message || "The overhead values could not be saved.";
};

const extractFieldErrors = (error) => {
  const payload = getErrorPayload(error);
  const result = {};
  const errors = Array.isArray(payload?.errors) ? payload.errors : [];

  errors.forEach((entry) => {
    const accountId = entry?.accountId ?? entry?.id ?? entry?.fieldId;
    if (accountId == null) return;
    result[String(accountId)] = entry?.message || entry?.detail || "The value could not be saved.";
  });

  return result;
};

const getResponseFieldKeys = (overheads = []) => {
  const keys = new Set();
  (overheads || []).forEach((parent) => {
    keys.add(String(parent.id));
    (parent.content || []).forEach((child) => keys.add(String(child.id)));
  });
  return keys;
};

export function classifySaveResult(result, expectedFieldKeys = []) {
  const normalizedResult = Array.isArray(result) ? { ok: true, data: result, error: null } : result;
  const responseKeys = getResponseFieldKeys(normalizedResult?.data);
  const hasCompleteResponse = expectedFieldKeys.every((fieldKey) => responseKeys.has(String(fieldKey)));

  if (normalizedResult?.ok === true && Array.isArray(normalizedResult.data) && hasCompleteResponse) {
    return { kind: "success", overheads: normalizedResult.data };
  }

  const status = normalizedResult?.error?.response?.status;
  const isValidation = status === 400 || status === 409 || status === 422;

  return {
    kind: isValidation ? "validation" : "network",
    message: getErrorMessage(normalizedResult?.error),
    fieldErrors: extractFieldErrors(normalizedResult?.error),
  };
}

export async function reconcileAfterFailure({ surveyAdapter, translate }) {
  try {
    const data = await surveyAdapter.fetchData(translate);
    if (!Array.isArray(data?.companyOverheads)) {
      return { ok: false, message: "The latest overhead values could not be loaded." };
    }
    return { ok: true, overheads: data.companyOverheads };
  } catch (error) {
    return { ok: false, message: getErrorMessage(error) };
  }
}
